module.exports = __webpack_public_path__ + "img/wave-repeat-pattern-gray-100.71d42f5.png";